import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OnBoardingDocsPageUI from './OnBoardingDocsPageUI'

class OnBoardingDocsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loading: true,
      onboardingDocsData: null,
      uploadMode: false,
      uploadSubmitted: false,
      uploadErrorList: []
    }
  }

  componentDidMount() {
    this.getOnBoardingDocs(this.props.context)
  }

  getOnBoardingDocs(context) {
    const accountId = this.props.match && this.props.match.params ? this.props.match.params.accountId : null
    if (!accountId) {
      this.setState({
        errorList: ['Account ID is missing'],
        loading: false
      })
      return
    }

    const cacheManager = new CacheManager({
      resource: '/api/su/accounts/' + accountId + '/onBoardingDocs',
      cacheKey: CacheKeys.OnBoardingDocs(accountId),
      callback: this.getOnBoardingDocsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getOnBoardingDocsCallback = (response) => {
    if (response && response.success === 'OK') {
      this.setState({
        onboardingDocsData: response,
        loading: false,
        errorList: null
      })
    } else {
      const errorMessage = (response && response.errorList && response.errorList.length > 0)
        ? response.errorList
        : ['Failed to fetch onboarding docs data']
      this.setState({
        onboardingDocsData: response || null,
        errorList: Array.isArray(errorMessage) ? errorMessage : [errorMessage],
        loading: false
      })
    }
  }

  onRefreshClick = () => {
    const accountId = this.props.match && this.props.match.params ? this.props.match.params.accountId : null
    if (accountId) {
      try {
        CacheManager.removeObject(CacheKeys.OnBoardingDocs(accountId))
      } catch (e) {
        // ignore
      }
    }
    this.setState({ loading: true, errorList: null, onboardingDocsData: null }, () => {
      this.getOnBoardingDocs(this.props.context)
    })
  }

  handleFileDownload = (fileName) => {
    const accountId = this.props.match && this.props.match.params ? this.props.match.params.accountId : null
    if (!accountId || !fileName) return

    const cacheManager = new CacheManager({
      resource: '/api/su/accounts/' + accountId + '/files/' + encodeURIComponent(fileName) + '/fileDownloadSignedUrl',
      cacheKey: 'FileDownload:' + accountId + ':' + fileName,
      callback: (response) => {
        if (response && response.errorList && response.errorList.length === 0 && response.signedUrl && response.signedUrl.signedUrl) {
          window.open(response.signedUrl.signedUrl, '_blank')
        }
      },
      ttlInSecs: 60
    })
    cacheManager.getObject2(this.props.context)
  }

  onProjectedCashflowUploadClick = () => {
    this.setState({ uploadMode: true, uploadErrorList: [] })
  }

  onUploadCancel = () => {
    this.setState({ uploadMode: false })
  }

  onProjectedCashflowUploaded = (fileId, fileName, fileType, fileSize) => {
    const accountId = this.props.match && this.props.match.params ? this.props.match.params.accountId : null
    if (!accountId) return

    this.setState({ uploadMode: false, uploadSubmitted: true, uploadErrorList: [] })

    const payload = {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize ? String(fileSize) : '0'
      }
    }

    RestApiUtils.post(
      this.props.context,
      `/api/su/accounts/${accountId}/projectedCashflows/files/validation`,
      this.onProjectedCashflowValidationCallback,
      payload
    )
  }

  onProjectedCashflowValidationCallback = (response) => {
    this.setState({ uploadSubmitted: false })
    const accountId = this.props.match && this.props.match.params ? this.props.match.params.accountId : null
    if (accountId) {
      try {
        CacheManager.removeObject(CacheKeys.OnBoardingDocs(accountId))
      } catch (e) {
        // ignore
      }
    }

    if (response && response.errorList && response.errorList.length > 0) {
      let errorList = []
      response.errorList.forEach(error => {
        errorList.push(typeof error === 'string' ? error : error.message)
      })
      this.setState({ uploadErrorList: errorList })
    } else {
      this.setState({ uploadErrorList: [] })
      this.onRefreshClick()
    }
  }

  onProjectedCashflowDeleteClick = (fileName) => {
    const accountId = this.props.match && this.props.match.params ? this.props.match.params.accountId : null
    if (!accountId || !fileName) return

    RestApiUtils.delete(
      this.props.context,
      `/api/su/accounts/${accountId}/projectedCashflows/files/${encodeURIComponent(fileName)}`,
      this.onProjectedCashflowDeleteCallback,
      null
    )
  }

  onProjectedCashflowDeleteCallback = (response) => {
    const accountId = this.props.match && this.props.match.params ? this.props.match.params.accountId : null
    if (accountId) {
      try {
        CacheManager.removeObject(CacheKeys.OnBoardingDocs(accountId))
      } catch (e) {
        // ignore
      }
    }

    if (response && response.errorList && response.errorList.length > 0) {
      let errorList = []
      response.errorList.forEach(error => {
        errorList.push(typeof error === 'string' ? error : error.message)
      })
      this.setState({ errorList: errorList })
    } else {
      this.onRefreshClick()
    }
  }

  render() {
    const { context, match } = this.props
    const accountId = match && match.params ? match.params.accountId : null

    return (
      <OnBoardingDocsPageUI
        context={context}
        accountId={accountId}
        errorList={this.state.errorList}
        loading={this.state.loading}
        onboardingDocsData={this.state.onboardingDocsData}
        onFileDownloadClick={this.handleFileDownload}
        onRefreshClick={this.onRefreshClick}
        uploadMode={this.state.uploadMode}
        uploadSubmitted={this.state.uploadSubmitted}
        uploadErrorList={this.state.uploadErrorList}
        onProjectedCashflowUploadClick={this.onProjectedCashflowUploadClick}
        onUploadCancel={this.onUploadCancel}
        onProjectedCashflowUploaded={this.onProjectedCashflowUploaded}
        onProjectedCashflowDeleteClick={this.onProjectedCashflowDeleteClick}
      />
    )
  }
}

export default withRouter(OnBoardingDocsPageSF)
